import classNames from "classnames";
import React, { FC } from "react";

import { Badge } from "./Badge";

interface ISuggestedBadgeProps {
  isChecked?: boolean;
  onClick?: () => void;
  className?: string;
  notCheckedIcon?: string;
}

export const SuggestedBadge: FC<ISuggestedBadgeProps> = ({
  className,
  children,
  isChecked = false,
  onClick,
  notCheckedIcon,
}) => {
  const baseClass = "suggested-badge";

  return (
    <Badge
      backgroundColor={isChecked ? "info" : "background-card"}
      borderColor={isChecked ? "info" : "grey4"}
      color={isChecked ? "background-card" : "black"}
      onClick={onClick}
      className={classNames(baseClass, className)}
      icon={isChecked ? "checkbox" : notCheckedIcon}
      iconColor={isChecked ? "background-card" : "grey2"}
      contentMargin={[false, "sm"]}>
      {children}
    </Badge>
  );
};
